// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.clientNav[data-v-549e0b1f]
	{
		position: sticky;
		top: 0px;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		background-color: var(--primary-color);
		border-bottom: 1px solid #AAAAAA;
}
.clientNav[data-v-549e0b1f] > *
		{
			padding: 10px 10px;
			cursor: pointer;
			font-size: 20px;
			color: var(--text-color-on-primary-color);
			text-decoration: none;
}
.clientNav[data-v-549e0b1f] > *:hover
			{
				/*background-color: #1e78af;*/
				/*background-color: #2187c5;*/
				/*background-color: #2596da;*/
				background-color: var(--primary-color-light1);
}
.router-link-exact-active[data-v-549e0b1f]
	{
		text-decoration: underline;
}
.systemName[data-v-549e0b1f]
	{
		flex: 1 1 auto;
		align-content: flex-start;
		text-decoration: none;
		white-space: nowrap;
		text-overflow: clip;
		overflow-x: hidden;
}
.notifyButton[data-v-549e0b1f]
	{
		padding: 0px 10px;
		line-height: 40px;
}
.notifications_icon[data-v-549e0b1f]
	{
		width: 24px;
		height: 24px;
		fill: currentColor;
		vertical-align: middle;
}
@media (min-width: 600px)
	{
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/ClientTopNav.vue"],"names":[],"mappings":";AA4CC;;EAEC,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;AACjC;AAEC;;GAEC,kBAAkB;GAClB,eAAe;GACf,eAAe;GACf,yCAAyC;GACzC,qBAAqB;AACtB;AAEC;;IAEC,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6CAA6C;AAC9C;AAEF;;EAEC,0BAA0B;AAC3B;AAEA;;EAEC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACnB;AAEA;;EAEC,iBAAiB;EACjB,iBAAiB;AAClB;AAEA;;EAEC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACvB;AAEA;;AAEA","sourcesContent":["<template>\r\n\t<nav id=\"topNav\" class=\"clientNav\">\r\n\t\t<router-link :to=\"{name: 'clientStatus' }\" class=\"systemName\">{{title}} {{serverVersion}}</router-link>\r\n\t\t<!--<a role=\"button\" @click=\"notifyClicked\" class=\"notifyButton\"><vsvg sprite=\"notifications_active\" class=\"notifications_icon\" /></a>-->\r\n\t\t<router-link :to=\"{ name: 'clientNotificationsSetup' }\"><vsvg sprite=\"notifications_active\" class=\"notifications_icon\" /></router-link>\r\n\t\t<router-link :to=\"{name: 'clientManage' }\">{{userName}}</router-link>\r\n\t</nav>\r\n</template>\r\n\r\n<script>\r\n\timport svg1 from 'appRoot/images/sprite/notifications_active.svg';\r\n\timport svg2 from 'appRoot/images/sprite/notifications_off.svg';\r\n\r\n\texport default {\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tserverVersion: appContext.serverVersion\r\n\t\t\t};\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\ttitle()\r\n\t\t\t{\r\n\t\t\t\treturn appContext.systemName;\r\n\t\t\t},\r\n\t\t\tuserName()\r\n\t\t\t{\r\n\t\t\t\tlet un = this.$store.state.userData.Name;\r\n\t\t\t\tif (!un)\r\n\t\t\t\t\tun = \"User\";\r\n\t\t\t\treturn un;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tnotifyClicked()\r\n\t\t\t{\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.clientNav\r\n\t{\r\n\t\tposition: sticky;\r\n\t\ttop: 0px;\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: nowrap;\r\n\t\tflex-direction: row;\r\n\t\tbackground-color: var(--primary-color);\r\n\t\tborder-bottom: 1px solid #AAAAAA;\r\n\t}\r\n\r\n\t\t.clientNav > *\r\n\t\t{\r\n\t\t\tpadding: 10px 10px;\r\n\t\t\tcursor: pointer;\r\n\t\t\tfont-size: 20px;\r\n\t\t\tcolor: var(--text-color-on-primary-color);\r\n\t\t\ttext-decoration: none;\r\n\t\t}\r\n\r\n\t\t\t.clientNav > *:hover\r\n\t\t\t{\r\n\t\t\t\t/*background-color: #1e78af;*/\r\n\t\t\t\t/*background-color: #2187c5;*/\r\n\t\t\t\t/*background-color: #2596da;*/\r\n\t\t\t\tbackground-color: var(--primary-color-light1);\r\n\t\t\t}\r\n\r\n\t.router-link-exact-active\r\n\t{\r\n\t\ttext-decoration: underline;\r\n\t}\r\n\r\n\t.systemName\r\n\t{\r\n\t\tflex: 1 1 auto;\r\n\t\talign-content: flex-start;\r\n\t\ttext-decoration: none;\r\n\t\twhite-space: nowrap;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow-x: hidden;\r\n\t}\r\n\r\n\t.notifyButton\r\n\t{\r\n\t\tpadding: 0px 10px;\r\n\t\tline-height: 40px;\r\n\t}\r\n\r\n\t.notifications_icon\r\n\t{\r\n\t\twidth: 24px;\r\n\t\theight: 24px;\r\n\t\tfill: currentColor;\r\n\t\tvertical-align: middle;\r\n\t}\r\n\r\n\t@media (min-width: 600px)\r\n\t{\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
